export const ShowContent = {
	init: function() {
		document.querySelectorAll('.js-show-content').forEach(element => {
			element.addEventListener('click', event => {
				event.preventDefault();
				element.classList.add('u-hidden');
				let maxHeight = 0;

				document.querySelectorAll('[data-content-id="' + element.dataset.targetId + '"]').forEach(target => {
					maxHeight = target.style.maxHeight;
					target.style.maxHeight = 'none';
					target.classList.remove('u-fade-out--white');
					target.classList.remove('u-fade-out--white-30');
				});

				// add hidden if class present in dataset
				if (element.dataset.hidden) {
					document.querySelector(element.dataset.hidden).addEventListener('click', event => {
						event.preventDefault();

						element.classList.remove('u-hidden');
						document.querySelectorAll('[data-content-id="' + element.dataset.targetId + '"]').forEach(target => {
							target.style.maxHeight = maxHeight;
							target.classList.add('u-fade-out--white');
							target.classList.add('u-fade-out--white-30');
						});
					})
				}

				return false;
			});
		});
	},
};

ShowContent.init();
